import { render, staticRenderFns } from "./AppContactsChannelConfig.vue?vue&type=template&id=3f2b34dc&scoped=true"
import script from "./AppContactsChannelConfig.vue?vue&type=script&lang=js"
export * from "./AppContactsChannelConfig.vue?vue&type=script&lang=js"
import style0 from "./AppContactsChannelConfig.vue?vue&type=style&index=0&id=3f2b34dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b34dc",
  null
  
)

export default component.exports